import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import AHDate from "_shared/dates/date";
import { jwtDecode, type JwtPayload } from "jwt-decode";
import UserAuthTokenSchema, { UserAuthTokenJSON, UserAuthTokenParams } from "users/auth/tokens/user-auth-token-schema";

export default class UserAuthToken {
  public static readonly EXAMPLE: UserAuthToken = UserAuthToken.create({
    value:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxMjM0NTY3ODkwIiwidXNlcm5hbWUiOiJ0ZXN0VXNlciIsImlhdCI6MTYxNjIzOTAyMiwiZXhwIjoxNjE2MjQyNjIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
    tokenExp: new AHDate(Date.now() + 3600 * 1000), // 1 hour from now
  });

  public static create(values: UserAuthTokenParams): UserAuthToken {
    const parsed = UserAuthTokenSchema.validate(values);
    return new UserAuthToken(parsed);
  }

  public static fromJSON(json: UserAuthTokenJSON | null | undefined): UserAuthToken | null | undefined {
    const parsed = UserAuthTokenSchema.deserialize(json);
    if (isNullOrUndefined(parsed)) return parsed;
    return new UserAuthToken(parsed);
  }

  public readonly value: string;
  public readonly data: JwtPayload;
  public readonly tokenExp: AHDate;

  public get isExpired(): boolean {
    return this.tokenExp.isBefore();
  }

  public toJSON(): UserAuthTokenJSON | null | undefined {
    return UserAuthTokenSchema.serialize(this);
  }

  public isEqualTo(other: UserAuthToken | null | undefined): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return `UserAuthToken (
      value: ${this.value} 
      data: ${JSON.stringify(this.data)} 
      tokenExp: ${this.tokenExp.toISOString()}
    )`;
  }

  public constructor(params: UserAuthTokenParams) {
    UserAuthTokenSchema.validate(params);
    this.value = params.value;
    this.data = jwtDecode(params.value);
    this.tokenExp = params.tokenExp;
  }
}
